import React from "react";
import { FaFacebookMessenger } from "react-icons/fa";
import { FaTelegram, FaInstagram } from "react-icons/fa6";
import { MdOutlineSms } from "react-icons/md";
import {
  IoIosChatbubbles,
  IoLogoInstagram,
  IoLogoGoogle,
} from "react-icons/io";
import { LuMessageSquare } from "react-icons/lu";
import { TbBrandWhatsapp } from "react-icons/tb";
import styled from "styled-components";
import "./Avatar.css";

const sizes = {
  sm: {
    width: "20px",
    height: "20px",
  },
  md: {
    width: "30px",
    height: "30px",
  },
  lg: {
    width: "40px",
    height: "40px",
  },
  xl: {
    width: "60px",
    height: "60px",
  },
};

const AvatarImage = styled.div`
  background: url(${(props) =>
      props.image ? props.image : "/images/user_avtar.png"})
    center no-repeat;
  background-size: contain;
`;

const dotStyle = {
  online: {
    display: "inline-block",
    position: "absolute",
    bottom: "0",
    right: "0px",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: "#4CB944",
  },
};

const Avatar = ({
  imageUrl,
  altText,
  size = "sm",
  showStatus = false,
  status,
  showInitials = false,
  ...props
}) => {
  const avatarStyle = {
    ...sizes[size],
    borderRadius: "50%",
    objectFit: "cover",
    textAlign: "center",
    fontWeight: "600",
  };

  return (
    <div {...props}>
      <div style={{ position: "relative" }}>
        {showInitials && (
          <div
            className="d-flex justify-content-center align-items-center bg-dark text-white"
            style={avatarStyle}
          >
            IN
          </div>
        )}
        {!showInitials && (
          <img src={imageUrl} alt={altText} style={avatarStyle}></img>
        )}
        <span style={dotStyle[status] ? dotStyle[status] : {}}></span>
      </div>
    </div>
  );
};

const renderIcon = (type) => {
  // console.log("type112233", type);
  const style = {
    position: "absolute",
    right: "-4px",
    transform: "translateY(-50%)",
    marginTop: "-4px",
  };
  switch (type) {
    case "webchat":
      return <LuMessageSquare style={style} />;
      break;
    case "whatsapp":
      return <TbBrandWhatsapp style={style} />;
      break;
    case "instagram":
      return <IoLogoInstagram style={style} />;
      break;
    case "rcs":
      return <IoLogoGoogle style={style} />;
      break;
    case "facebook":
      return <FaFacebookMessenger style={style} />;
      break;
    case "telegram":
      return <FaTelegram style={style} />;
      break;
    case "sms":
      return <MdOutlineSms style={style} />;
      break;
    case "cpaas":
      return <IoIosChatbubbles style={style} />;
      break;
    case "NoImg":
      return;
      break;
    default:
      return <LuMessageSquare style={style} />;
      break;
  }
};

export const RenderInitials = ({ text, type }) => {
  // const { size } = this.props;
  if (typeof text === "number") {
    text = text.toString();
  }
  const initials = text ? (
    text
      .toString()
      .slice(0, 2)
      .toUpperCase()
  ) : (
    <AvatarImage className="avatar-img-initials" />
  );

  return (
    <span>
      <div
        className="initials"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          height: "42px",
          width: "42px",
          fontSize: "16px",
          fontWeight: "700",
          background: "#EBF8FF",
          borderRadius: "12px",
          color: "#4299E1",
          textAlign: "center",
          lineHeight: "initial",
          // padding: "12px",
        }}
      >
        {initials}
      </div>
      {renderIcon(type)}
    </span>
  );
};

export default Avatar;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Avatar/index.js